export const content = `
<p>Curățenia ecologică a trecut, în ultimii ani, de la un subiect de nișă la o cerință tot mai frecventă din partea companiilor care își doresc spații de lucru sănătoase și o amprentă de mediu mai redusă. Nu mai este un moft de marketing, ci un criteriu real în alegerea unui furnizor de servicii de curățenie, mai ales pentru firmele cu politici interne de sustenabilitate sau cu certificări de clădire verde.</p>

<figure style="margin: 2rem 0; text-align: center;">
  <img src="https://i.ibb.co/k2NmWKqG/Eco.jpg" alt="Curățenie ecologică green cleaning birou" style="width:100%; max-height:420px; object-fit:cover; border-radius:12px; box-shadow:0 6px 20px rgba(0,0,0,0.12);" loading="lazy" />
</figure>

<div style="background-color: #f7f9fc; border-left: 4px solid #1a73e8; padding: 1.5rem; margin: 2rem 0; border-radius: 0 8px 8px 0;">
  <p style="font-weight: 700; margin-bottom: 0.8rem; color: #1d2a3a;">Cuprins articol:</p>
  <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0; line-height: 1.8;">
    <li><a href="#ce-inseamna" style="color: #1a73e8; text-decoration: none; font-weight: 600;">1. Ce înseamnă, de fapt, curățenia ecologică</a></li>
    <li><a href="#de-ce-castiga-teren" style="color: #1a73e8; text-decoration: none; font-weight: 600;">2. De ce câștigă teren în rândul firmelor</a></li>
    <li><a href="#ce-presupune" style="color: #1a73e8; text-decoration: none; font-weight: 600;">3. Ce presupune concret o procedură de green cleaning</a></li>
    <li><a href="#vs-conventionala" style="color: #1a73e8; text-decoration: none; font-weight: 600;">4. Curățenie ecologică vs. curățenie convențională</a></li>
    <li><a href="#certificari" style="color: #1a73e8; text-decoration: none; font-weight: 600;">5. Certificările care contează cu adevărat</a></li>
    <li><a href="#beneficii" style="color: #1a73e8; text-decoration: none; font-weight: 600;">6. Beneficii reale pentru angajați și pentru firmă</a></li>
    <li><a href="#limite" style="color: #1a73e8; text-decoration: none; font-weight: 600;">7. Limitele curățeniei ecologice</a></li>
    <li><a href="#tranzitia" style="color: #1a73e8; text-decoration: none; font-weight: 600;">8. Cum începi tranziția fără să compromiți rezultatele</a></li>
  </ul>
</div>

<h2 id="ce-inseamna">Ce înseamnă, de fapt, curățenia ecologică</h2>
<p>Curățenia ecologică presupune folosirea unor produse, metode și echipamente concepute să reducă impactul asupra mediului și asupra sănătății persoanelor care folosesc spațiul curățat, comparativ cu soluțiile convenționale — fără a compromite eficiența reală a curățeniei.</p>
<p>Aceasta include mai multe componente, nu doar tipul de detergent folosit: formula chimică a produselor, ambalarea și concentrația lor, metodele de aplicare, echipamentele folosite (de exemplu, cele care reduc consumul de apă) și chiar modul de gestionare a deșeurilor rezultate din activitatea de curățenie.</p>

<h2 id="de-ce-castiga-teren">De ce câștigă teren în rândul firmelor</h2>
<ul>
  <li><strong>Politici interne de sustenabilitate</strong> — tot mai multe companii au obiective declarate de reducere a amprentei de mediu, iar serviciile contractate, inclusiv curățenia, sunt evaluate prin aceeași lentilă.</li>
  <li><strong>Certificări de clădire verde</strong> — standarde internaționale de certificare a clădirilor sustenabile includ, printre criterii, și tipul de produse și proceduri de curățenie folosite.</li>
  <li><strong>Sănătatea angajaților</strong> — expunerea redusă la substanțe chimice volatile este văzută tot mai des ca un factor de wellbeing la locul de muncă, nu doar ca o preocupare de mediu.</li>
  <li><strong>Imaginea firmei</strong> — pentru companiile cu vizitatori sau clienți frecvenți în sediu, o politică declarată de curățenie ecologică poate fi parte din imaginea publică a brandului.</li>
</ul>

<h2 id="ce-presupune">Ce presupune concret o procedură de green cleaning</h2>
<h3>Produse de curățare cu impact redus</h3>
<p>Detergenți și soluții formulate fără compuși organici volatili agresivi, biodegradabile și, ideal, certificate de organisme independente de mediu, nu doar etichetate generic drept "eco".</p>

<h3>Reducerea consumului de apă și energie</h3>
<p>Echipamente moderne de curățare — mașini de spălat pardoseli cu recirculare a apei, sisteme de dozare precisă a soluțiilor — reduc semnificativ consumul de apă și de produse chimice per suprafață curățată, comparativ cu metodele tradiționale.</p>

<h3>Gestionarea responsabilă a deșeurilor</h3>
<p>Reducerea consumului de materiale de unică folosință (lavete, mănuși, ambalaje) și colectarea selectivă a deșeurilor rezultate din activitatea de curățenie, acolo unde este posibil.</p>

<h3>Instruirea personalului</h3>
<p>O procedură de curățenie ecologică depinde, în mare măsură, de modul în care este aplicată. Personalul instruit corect dozează corespunzător produsele, evită risipa și știe când o metodă ecologică este suficientă și când este nevoie de o soluție mai riguroasă.</p>

<h2 id="vs-conventionala">Curățenie ecologică vs. curățenie convențională</h2>
<p>Pentru spațiile de birouri, serviciile de <a href="/curatenie-birouri-firme-spatii-comerciale">curățenie birouri și spații comerciale</a> pot integra soluții verzi adaptate fiecărui departament.</p>

<div style="overflow-x:auto; margin: 2rem 0;">
  <table style="width:100%; border-collapse:collapse; background:#fff; border-radius:8px; overflow:hidden; box-shadow:0 2px 10px rgba(0,0,0,0.05);">
    <thead>
      <tr style="background:#1a73e8; color:#fff; text-align:left;">
        <th style="padding:12px 16px;">Aspect</th>
        <th style="padding:12px 16px;">Curățenie Ecologică</th>
        <th style="padding:12px 16px;">Curățenie Convențională</th>
      </tr>
    </thead>
    <tbody>
      <tr style="border-bottom:1px solid #eee;">
        <td style="padding:12px 16px; font-weight:600;">Compoziția produselor</td>
        <td style="padding:12px 16px;">Formule biodegradabile, fără compuși agresivi</td>
        <td style="padding:12px 16px;">Eficiență ridicată, dar deseori cu compuși chimici mai duri</td>
      </tr>
      <tr style="border-bottom:1px solid #eee;">
        <td style="padding:12px 16px; font-weight:600;">Impact calitatea aerului</td>
        <td style="padding:12px 16px;">Emisii reduse de compuși volatili</td>
        <td style="padding:12px 16px;">Poate lăsa mirosuri și reziduuri chimice mai persistente</td>
      </tr>
      <tr style="border-bottom:1px solid #eee;">
        <td style="padding:12px 16px; font-weight:600;">Dezinfecție riguroasă</td>
        <td style="padding:12px 16px;">Eficientă pentru întreținerea curentă</td>
        <td style="padding:12px 16px;">Soluție testată în medii critice (spitale, laboratoare)</td>
      </tr>
      <tr>
        <td style="padding:12px 16px; font-weight:600;">Cost per unitate</td>
        <td style="padding:12px 16px;">Ușor mai ridicat, în scădere în ultimii ani</td>
        <td style="padding:12px 16px;">Adesea mai ieftină per litru</td>
      </tr>
    </tbody>
  </table>
</div>

<p>📌 <strong>Notă:</strong> Cele mai eficiente proceduri din practică nu sunt 100% ecologice sau 100% convenționale, ci o combinație gândită: soluții ecologice pentru întreținerea zilnică și soluții mai riguroase acolo unde igiena o cere.</p>

<h2 id="certificari">Certificările care contează cu adevărat</h2>
<p>Piața este plină de produse etichetate generic "green" sau "eco". Certificările recunoscute internațional oferă un standard verificabil:</p>
<ul>
  <li><strong>EU Ecolabel</strong> — certificarea europeană oficială pentru produse și servicii cu impact redus pe tot ciclul de viață.</li>
  <li><strong>Green Seal</strong> — standard recunoscut pentru produse de curățenie profesională.</li>
  <li><strong>Fișe tehnice de siguranță (SDS)</strong> — verificarea directă a compoziției rămâne cea mai sigură metodă.</li>
</ul>

<h2 id="beneficii">Beneficii reale pentru angajați și pentru firmă</h2>
<ul>
  <li><strong>Calitate mai bună a aerului interior</strong> — mai puține mirosuri chimice persistente și mai puține iritații respiratorii.</li>
  <li><strong>Reducerea riscurilor de expunere</strong> — protecție sporită pentru personalul care manipulează produsele zilnic.</li>
  <li><strong>Aliniere la cerințele clienților B2B</strong> — integrare în standardele de sustenabilitate cerute de parteneri.</li>
  <li><strong>Reducerea consumului de resurse</strong> — economii la consumul de apă și energie prin echipamente moderne. De asemenea, pentru spații mari precum <a href="/curatenie-galerii-comerciale">galerii comerciale</a>, optimizarea curățeniei aduce beneficii financiare substanțiale.</li>
</ul>

<h2 id="limite">Limitele curățeniei ecologice</h2>
<p>Curățenia ecologică nu este o soluție universală. În spații cu cerințe stricte de igienizare — bucătării profesionale, grupuri sanitare intens folosite — anumite soluții convenționale rămân mai eficiente.</p>

<h2 id="tranzitia">Cum începi tranziția fără să compromiți rezultatele</h2>
<p>Pentru a începe tranziția, identifică zonele cu trafic normal, menține soluțiile convenționale pentru zonele critice și instruiește echipa de curățenie. Dacă dorești o evaluare gratuită pentru spațiul tău, <a href="/contact-curatenie">contactează echipa Doral Cleaning</a>.</p>

<div style="background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%); border-radius: 12px; padding: 2rem; margin: 2.5rem 0; text-align: center; color: #fff;">
  <p style="font-size: 1.15rem; font-weight: 600; margin-bottom: 0.5rem;">Cere o ofertă personalizată!</p>
  <p style="margin-bottom: 1.2rem; opacity: 0.92;">Fiecare spațiu are nevoi diferite. Cere o ofertă personalizată astăzi și hai să discutăm concret despre proiectul tău de curățenie ecologică!</p>
  <a href="/contact-curatenie" style="background:#fff; color:#1a73e8; font-weight:700; padding:0.65rem 1.75rem; border-radius:8px; text-decoration:none; display:inline-block;">Contactează-ne</a>
</div>
`;

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Ce înseamnă curățenia ecologică (green cleaning)?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Curățenia ecologică presupune folosirea unor produse, metode și echipamente care reduc impactul asupra mediului și sănătății ocupanților, comparativ cu soluțiile de curățenie convenționale, fără a compromite eficiența curățeniei."
      }
    },
    {
      "@type": "Question",
      "name": "Produsele ecologice de curățenie sunt la fel de eficiente ca cele convenționale?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Pentru majoritatea sarcinilor de curățenie de întreținere, da. Pentru anumite tipuri de dezinfecție sau pete dificile, unele soluții convenționale rămân mai eficiente, motiv pentru care multe firme folosesc o abordare mixtă."
      }
    },
    {
      "@type": "Question",
      "name": "Curățenia ecologică costă mai mult decât cea convențională?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Costul variază în funcție de produsele și echipamentele alese, dar diferența s-a redus semnificativ în ultimii ani, iar economiile de consum de apă și energie pot compensa parțial orice diferență de preț."
      }
    },
    {
      "@type": "Question",
      "name": "Ce certificări confirmă că un produs de curățenie este cu adevărat ecologic?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Certificări recunoscute internațional precum EU Ecolabel sau Green Seal oferă o confirmare independentă a criteriilor de mediu îndeplinite de un produs, spre deosebire de etichetări generice de tip green sau eco fără certificare."
      }
    }
  ]
};
